







import Component, { mixins } from "vue-class-component";
import { isCallMessageDetails } from "@scrile/api-provider/dist/api/CallsProvider";
import { isImageFile, isVideoFile } from "@/lib/fileHelpers";
import { $t } from "@/lib/i18nHelpers";
import MessagePreviewMixin from "../mixins/MessagePreviewMixin";

@Component({ name: "MessagePreview" })
export default class MessagePreview extends mixins(MessagePreviewMixin) {
  public get opponentMessage() {
    return this.message.senderId !== this.authUserId;
  }

  public get isAttachmentOnly() {
    return this.message.text.trim() === "" && this.message.attachment;
  }

  public get text() {
    const message = this.message;
    const text = message.text.trim();
    if (message.attachment && text === "") {
      if (this.isImage) return $t("Photo");
      if (this.isVideo) return $t("Video");
    }
    if (isCallMessageDetails(message.details)) {
      return $t("Call");
    }
    return text;
  }
  public get isImage(): boolean {
    return isImageFile(this.message.attachment[0].file);
  }

  public get isVideo(): boolean {
    return isVideoFile(this.message.attachment[0].file);
  }
}
